module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 169.704 58.801",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }